import globals from "@/utils/globals";

const enabledViaURLParam = (key) => {
  try {
    return !!(new URL(document.location)).searchParams.get(key);
  } catch (e) {
    return false;
  }
};

const enabled = (key, featureFlags = globals.featureFlags || {}) => {
  const paramEnabled = enabledViaURLParam(key);

  return featureFlags[key] || paramEnabled;
};

export default {
  enabled
};
